import { defineComponent as _defineComponent } from 'vue';
import { TooltipProvider } from "reka-ui";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TooltipProvider',
    props: {
        delayDuration: { type: Number, required: false, default: 0 },
        skipDelayDuration: { type: Number, required: false },
        disableHoverableContent: { type: Boolean, required: false },
        disableClosingTrigger: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        ignoreNonKeyboardFocus: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get TooltipProvider() { return TooltipProvider; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
